import { memo } from 'react';
import { DefaultEdgeOptions, Edge, EdgeTypes, Node, NodeTypes, ReactFlow } from '@xyflow/react';
import { proOptions } from '../utils/flowConfig';

import '@xyflow/react/dist/style.css';

type ReadonlyFlowCanvasProps = {
  nodes: Node[];
  edges: Edge[];
  nodeTypes: NodeTypes;
  edgeTypes: EdgeTypes;
  defaultEdgeOptions?: DefaultEdgeOptions;
  width: number;
  height: number;
};

export const ReadonlyFlowCanvas = memo(
  ({ nodes, edges, nodeTypes, edgeTypes, defaultEdgeOptions, width, height }: ReadonlyFlowCanvasProps) => (
    <div className="w-full overflow-auto">
      <div className="pointer-events-none m-auto" style={{ width: `${width}px`, height: `${height}px` }}>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          nodeTypes={nodeTypes}
          edgeTypes={edgeTypes}
          defaultEdgeOptions={defaultEdgeOptions}
          nodeOrigin={[0, 0.5]}
          nodesDraggable={false}
          nodesFocusable={false}
          nodesConnectable={false}
          edgesFocusable={false}
          elementsSelectable={false}
          autoPanOnConnect={false}
          selectionOnDrag={false}
          panOnDrag={false}
          panOnScroll={false}
          zoomOnScroll={false}
          connectOnClick={false}
          zoomOnPinch={false}
          zoomOnDoubleClick={false}
          selectNodesOnDrag={false}
          proOptions={proOptions}
          disableKeyboardA11y
        />
      </div>
    </div>
  ),
);
